import { ModalContainer } from '@stepstone-fragment/login-registration';
import { EndpointClient } from 'types/endpoint';

export const containersClient: EndpointClient[] = [
  {
    name: 'modal',
    container: ModalContainer,
  },
];
